import authApi from '../utils/authApiHelper'

export const getUserData = (accessToken, clientNumber) => (
  authApi.get(
    `person-prc/1.0/client/person/${clientNumber}`,
    accessToken,
  )
    .then((res) => res)
)

export const updateUserData = (accessToken, clientNumber) => (
  authApi.post(
    `some-endpoint/${clientNumber}`,
    accessToken,
  )
    .then((res) => res)
)
